var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { ElectronService } from './electronService';
import { Injectable } from '@angular/core';
var ElectronServiceRef = (function (_super) {
    __extends(ElectronServiceRef, _super);
    function ElectronServiceRef() {
        return _super.call(this) || this;
    }
    return ElectronServiceRef;
}(ElectronService));
export { ElectronServiceRef };
ElectronServiceRef.decorators = [
    { type: Injectable },
];
/** @nocollapse */
ElectronServiceRef.ctorParameters = function () { return []; };



//////////////////
// WEBPACK FOOTER
// /Desenvolvimento/PMP/painel/~/ngx-electron/src/electronServiceRef.js
// module id = ../../../../ngx-electron/src/electronServiceRef.js
// module chunks = 37